/**
 * @generated SignedSource<<b97638dc1422988cbd00bfcd7c6aee77>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RejectSuggestionInputObject = {
  suggestionId: string;
};
export type reviewPage_RejectSuggestionMutation$variables = {
  input: RejectSuggestionInputObject;
};
export type reviewPage_RejectSuggestionMutation$data = {
  readonly rejectSuggestion: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly suggestion: {
      readonly id: string;
      readonly status: string;
    } | null | undefined;
  } | null | undefined;
};
export type reviewPage_RejectSuggestionMutation = {
  response: reviewPage_RejectSuggestionMutation$data;
  variables: reviewPage_RejectSuggestionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Suggestion",
  "kind": "LinkedField",
  "name": "suggestion",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "reviewPage_RejectSuggestionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RejectSuggestionMutationPayload",
        "kind": "LinkedField",
        "name": "rejectSuggestion",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "reviewPage_RejectSuggestionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RejectSuggestionMutationPayload",
        "kind": "LinkedField",
        "name": "rejectSuggestion",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c73a7481f07e090e83b647fa8d9bf38d",
    "id": null,
    "metadata": {},
    "name": "reviewPage_RejectSuggestionMutation",
    "operationKind": "mutation",
    "text": "mutation reviewPage_RejectSuggestionMutation(\n  $input: RejectSuggestionInputObject!\n) {\n  rejectSuggestion(input: $input) {\n    suggestion {\n      id\n      status\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f8596ecd773dc90882f2463f4b4b973b";

export default node;
